import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { faqs } from "@/data/content";
import { SectionHeading, Reveal } from "@/components/motion";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background py-16 sm:py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="10"
          eyebrow="FAQ"
          title="Frequently Asked Questions"
          sub="Answers to common questions about consultations, appointments and the clinic."
        />
        <div className="mt-12 space-y-3" data-testid="faq-list">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={Math.min(i, 4) * 0.5}>
                <div className="bg-white rounded-2xl border border-slate-200/80 shadow-soft overflow-hidden">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`faq-question-${i}`}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  >
                    <span className="font-semibold text-slate-900 text-sm sm:text-base">{f.q}</span>
                    <ChevronDown
                      size={18}
                      className={`shrink-0 text-teal-700 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 pb-6 text-sm sm:text-base text-slate-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
